var map = {
	"./c_1.jpg": 637389,
	"./c_1_author.jpg": 536426,
	"./c_2.jpg": 399247,
	"./c_2_author.jpg": 871800,
	"./c_3.jpg": 142849,
	"./c_3_author.jpg": 542324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56161;